import _ from "lodash"
import keycloak from "../../keycloak"
import env from "../../context/Env"

class LicenceService {
    private readonly CUSTOMER_LICENSE = "customerLicense"

    private readonly INTERNAL_LICENSE = "internalLicense"

    private readonly EULA_ACCEPTED = "eula-accepted"

    isWithOutLicence = (roles: string[]): boolean => {
        return (
            _.isUndefined(roles) ||
            _.isEmpty(roles) ||
            (!roles.includes(this.INTERNAL_LICENSE) &&
                !roles.includes(this.CUSTOMER_LICENSE))
        )
    }

    isEulaAccepted = (roles: string[]): boolean =>
        roles && roles.includes(this.EULA_ACCEPTED)

    // User could have both licences:internal and external. External license overrules the internal license.
    isOnlyInternal = (roles: string[]): boolean => {
        return this.isInternal(roles) && !this.isCustomer(roles)
    }

    isCustomer = (roles: string[]): boolean => {
        return (
            roles.includes(this.CUSTOMER_LICENSE) && this.isEulaAccepted(roles)
        )
    }

    isInternal = (roles: string[]): boolean => {
        return (
            roles.includes(this.INTERNAL_LICENSE) && this.isEulaAccepted(roles)
        )
    }

    willExpire = (): boolean => {
        if (keycloak.tokenParsed?.licences_info) {
            const validLicences = Object.values(
                keycloak.tokenParsed.licences_info
            )
                .filter(
                    (licence: any) =>
                        licence.clientId === env("KEYCLOAK_CLIENT_ID")
                )
                .filter((licence: any) => {
                    const date: Date = new Date(Date.parse(licence.expiration))
                    date.setDate(
                        date.getDate() - +env("LICENCE_WILL_EXPIRE_AFTER_DAYS")
                    )
                    return date < new Date()
                })
            return validLicences.length > 0
        }
        return false
    }
}

export default new LicenceService()
